import { LoadingStyled } from "@/pages/Mobile/styled"
import styled from "styled-components"

export const ResumeListStyled = styled.div`
    padding: 16px;
    border-radius: 16px 16px 0px 0px;
    background-color: #fff;
    .header {
        margin-bottom: 22px;
        padding-top: 6px;
        h2 {
            font-size: 14px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            color: #2C2C2C;
            margin: 0;
            position: relative;
            padding-left: 8px;
        }

        h2::after {
            content: "";
            position: absolute;
            background: #11BBA6;
            width: 2px;
            border-radius: 2px;
            /* height: 100%; */
            left: 0;
            top: 0;
            bottom: 0;
        }
        span {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999; 
        }
    }
    .resume-list {
        display: grid;
        grid-template-columns: 1fr 1fr;
        column-gap: 9px;
        .resume-item {
            margin-bottom: 16px;
        }
        .resume-item-img {
            border-radius: 8px;
            border: 1px solid #E2E2E2;
            margin-bottom: 8px;
        }
        .resume-item-title {
            padding-left: 2px;
            font-size: 12px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #343542;
        }
    }
    .resume-use {
        overflow-x: scroll;
        margin-bottom: 12px;
    }
    .resume-use::-webkit-scrollbar {
        display: none;
    }
`

export const TagStyled = styled.div`
    padding: 0 10px;
    height: 25px;
    margin-right: 8px;
    border-radius: 13px;
    background: #F7F7F7;
    flex-shrink: 0;
    ${props => props.$active ? `
        background: ${props.theme.colors.primary};
        color: #fff;
    ` : ''}
`

export const PopupContentStyled = styled.div`
    padding: 20px;
    .resume-title {
        font-size: 13px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #2C2C2C;
        margin-bottom: 24px;
    }
    img {
        border: 1px solid #E4E4E4;
        border-radius: 8px;
    }
    .resume-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 44px;
        background: #11BBA6;
        border-radius: 4px;
        margin-top: 33px;
        color: #ffffff;
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
    }
`

export const ResumeButton = styled(LoadingStyled)`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 44px;
    background: #11BBA6;
    border-radius: 4px;
    margin-top: 33px;
    color: #ffffff;
    font-size: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
`

export const rightSvg = <div className="flex-center" dangerouslySetInnerHTML={{
    __html: `
<?xml version="1.0" encoding="UTF-8"?>
<svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>切片</title>
    <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="点击导入简历" transform="translate(-321.000000, -227.000000)" fill="#999999" fill-rule="nonzero">
            <g id="返回" transform="translate(321.000000, 227.000000)">
                <path d="M8.99008332,1.62606369 C9.23686819,1.37590766 9.6371048,1.3651263 9.89699915,1.60163368 C10.1568935,1.83814105 10.1837891,2.23761848 9.95794314,2.50682923 L9.91996218,2.54873926 L5.46964055,7.03409505 L9.91603312,11.445126 C10.1571558,11.6843435 10.175354,12.0682104 9.95794314,12.3291658 L9.91996218,12.3714032 C9.68065744,12.612428 9.29679472,12.6304838 9.03592242,12.4129858 L8.99368497,12.3750049 L4.08235298,7.50296354 C3.84132822,7.2636588 3.82327245,6.87979608 4.04077036,6.61892378 L4.07875134,6.57668633 L8.99008332,1.62606369 L8.99008332,1.62606369 Z" id="路径" transform="translate(7.000000, 6.997989) scale(-1, 1) translate(-7.000000, -6.997989) "></path>
            </g>
        </g>
    </g>
</svg>
`}} />